import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplyForLeavesModule } from '../apply-for-leaves/apply-for-leaves.module';
import { ApplyForLeavesRepository } from '../apply-for-leaves/repository/apply-for-leaves.repository';
import { TypesOfLeaves } from '../types-of-leaves/types-of-leaves.entity';
import { TypesOfLeavesModule } from '../types-of-leaves/types-of-leaves.module';
import { TypesOfLeavesService } from '../types-of-leaves/types-of-leaves.service';
import { EmployeeLeavesAdapter } from './dto/employee-leaves.adapter';
import { EmployeeLeavesController } from './employee-leaves.controller';
import { EmployeeLeavesService } from './employee-leaves.service';
import { EmployeeLeavesRepository } from './entity/employee-leaves.repository';
import { DepartmentService, EmployeeService } from '@gtpl/shared-services/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
@Module({
  imports: [
    TypeOrmModule.forFeature([TypesOfLeaves,ApplyForLeavesRepository,EmployeeLeavesRepository]),
    forwardRef(() => ApplyForLeavesModule),
    forwardRef(() => TypesOfLeavesModule)
  ],
  controllers: [EmployeeLeavesController],
  providers: [EmployeeLeavesService,EmployeeLeavesAdapter,ApplicationExceptionHandler,TypesOfLeavesService,EmployeeService,DepartmentService,LogsService],
  exports: [EmployeeLeavesService,EmployeeLeavesAdapter]
})
export class EmployeeLeavesModule {}
